import React from 'react';

const Card = (props) => {
    const {
        title,
        classes     = "",
        controls    = null,
        noMargin    = false,
        noPadding   = false,
    } = props;

    let cardClasses = "card rounded-0 m-0 "+classes;
    if (!noMargin) {
        cardClasses += " mb-4";
    }

    if (!noPadding) {
        cardClasses += " p-4";
    } else {
        cardClasses += " p-0";
    }

    return (
        <div className={cardClasses}>
            {(!!title || !!controls) && (
                <div className="d-flex justify-content-between align-items-center mb-4">
                    {!!title && (
                        <h1 className={"h4 mb-0 text-eh-navy"}>{title}</h1>
                    )}
                    {controls}
                </div>
            )}
            {!!props.children ? props.children : null}
        </div>
    );
}

export default Card;
